<template>

    <Head :title="__('Login')" />

    <div class="flex align-items-center justify-content-center min-h-screen p-3">
        <v-form name="formLogin2Fa"
                class="w-full"
                style="max-width:30rem"
                @keyup.enter="login">
            <Card>
                <template #header>
                    <div class="flex justify-content-center pt-4">
                        <Image :src="qrCodeImage"
                               width="220" />
                    </div>
                </template>

                <template #title>
                    <div class="text-center">{{ __('Enter security code') }}</div>
                </template>

                <template #content>
                    <div class="flex flex-column gap-2 mb-4">
                        <InputText type="text"
                                   id="generatedCode"
                                   name="generatedCode"
                                   size="small"
                                   class="w-full"
                                   v-model="form.generatedCode" />
                    </div>

                    <Message severity="info"
                             :closable="false"
                             class="mb-3">
                        <p class="font-semibold mb-2">Jeśli powyżej pojawił się kod QR:</p>
                        <ol class="pl-3 m-0">
                            <li>Ze sklepu Play lub AppStore pobierz na telefon aplikację Google Authenticator
                                <Image :src="gaIcon"
                                       width="24"
                                       style="display:inline-block" />
                            </li>
                            <li>Otwórz aplikację i kliknij przycisk "Dodaj kod"</li>
                            <li>Zeskanuj kod QR z ekranu</li>
                            <li>Wpisz wygenerowany numer do pola powyżej</li>
                            <li>Kliknij "Login"</li>
                        </ol>
                    </Message>

                    <Message severity="warn"
                             :closable="false"
                             class="mb-4">
                        <p class="font-semibold mb-2">Jeśli powyżej nie pojawił się kod QR:</p>
                        <ol class="pl-3 m-0">
                            <li>Otwórz na telefonie aplikację Google Authenticator
                                <Image :src="gaIcon"
                                       width="24"
                                       style="display:inline-block" />
                            </li>
                            <li>Wpisz wygenerowany numer do pola powyżej</li>
                            <li>Kliknij "Login"</li>
                        </ol>
                    </Message>

                    <Button @click="login"
                            label="Login"
                            icon="pi pi-sign-in"
                            class="w-full" />
                </template>
            </Card>
        </v-form>
    </div>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { Head } from '@inertiajs/vue3'

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Card from 'primevue/card';
import Message from 'primevue/message';

import Layout from '@layouts/LayoutNoMenuNoFooter.vue'
import Image from '@helper/Image.vue'
import { __ } from '@helper/utils.js'
import { startSplash } from '@helper/constants.js'

defineOptions({ layout: Layout })

const props = defineProps({
    qrCodeImage: String,
    email: String,
    password: String,
    remember: Boolean,
    removeSession: Boolean,
    ga2FaToken: String,
    gaIcon: String
})

// -----------------------------------------------------

const form = useForm({ generatedCode: '', 'email': props.email, 'password': props.password, 'remember': props.remember, 'removeSession': props.removeSession, 'ga2FaToken': props.ga2FaToken })

const login = () => {
    form.post(route('ga2fa-verify'), {
        onSuccess: () => {
        },
        onError: (errors) => { console.error(errors) },
    })
}
</script>

<style lang="scss"
       scoped></style>
